import { getUseRoundKey, useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils/unwrapResponse'
import {
  ManagerResearchVisitEvent,
  PutResearchVisitEventManagerProcessing,
} from '@/types/api/entities'
import { APIErrorResponse } from '@/types'
import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { QUERY_KEYS } from '@/constants'

export const usePutRoundStatus = (
  id: number
): UseMutationResult<
  ManagerResearchVisitEvent,
  APIErrorResponse,
  PutResearchVisitEventManagerProcessing
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    (params) =>
      client
        .put(`/plannings/events/manager/${id}/manager_processing/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: (data) => {
        const queryKey = getUseRoundKey(id)

        queryClient.setQueryData(queryKey, data)
        queryClient.invalidateQueries(QUERY_KEYS.PLANNING_EVENTS_MANAGER)
      },
      onError: (error) => {
        alert(error)
      },
    }
  )
}
